export function initPixel({ pixelId, data = null, options = null }) {
    fbq("init", pixelId, data, options);
}

export function dispatchPageViewEvent({ data = null, options = null }) {
    fbq("track", "PageView", data, options);
}

export function dispatchFacebookPixelInitiateCheckoutEvent({
    data = null,
    options = null,
}) {
    fbq("track", "InitiateCheckout", data, options);
}

export function dispatchFacebookAddPaymentInfoEvent({
    data = null,
    options = null,
}) {
    fbq("track", "AddPaymentInfo", data, options);
}

export function dispatchFacebookPixelPurchaseEvent({
    data = null,
    options = null,
}) {
    fbq("track", "Purchase", data, options);
}
